<template>
	<section class="join-page">
        <div class="container">
            <JoinForm />
        </div>
	</section>
</template>

<script>
    import JoinForm from '@/components/Forms/JoinForm';

    export default {
        name: 'Join',
        head() {
            return {
                title: this.$t('pages.join.title'),
            }
        },
        //transition: 'fade',
        components: {
            JoinForm
        },
        layout: 'authorization',
    };
</script>

<style lang="scss">
    @import "~assets/css/_vars.scss";
    .join-page {
        position: relative;
        width: 100%;
        background-color: $sectionIntermediateBg;
        padding-top: 30px;
        padding-bottom: 100px;
    }

    @media (max-width: $breakpoint-desktops) {
        .join-page {
            padding-bottom: 45px;
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .join-page {
            padding-left: 30px;
            padding-bottom: 70px;
        }
    }

    @media (max-width: $breakpoint-phone) {
        .join-page {
            padding-left: 0;
            padding-bottom: 110px;
        }
    }
</style>
